<template>
  <div class="home">
    <Banner />
    <NewsBar />
    <NewsReport />
    <OtherReport />
  </div>
</template>

<script>
import Banner from "components/home/Banner";
import NewsBar from "components/home/NewsBar";
import NewsReport from "components/home/NewsReport";
import OtherReport from "components/home/OtherReport";

export default {
  components: {
    Banner,
    NewsBar,
    NewsReport,
    OtherReport,
  },
};
</script>

<style>
.home {
  width: 100%;
  background-color: #f7f5f4;
}
</style>
